import React from 'react';
import {
    Box,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Typography,
    Pagination,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import './admin-pagination.scss';

export default function AdminPagination({
    page,
    pageSize,
    total,
    onPageChange,
    onPageSizeChange,
    pageSizeOptions = [10, 20, 50],
}) {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const totalPages = Math.max(1, Math.ceil(total / pageSize));

    const rangeStart = total === 0 ? 0 : page * pageSize + 1;
    const rangeEnd = Math.min((page + 1) * pageSize, total);

    return (
        <Box className="admin-pagination">
            <Box className="admin-pagination-left">
                <FormControl size="small" sx={{ minWidth: 90 }}>
                    <InputLabel id="page-size-label">Itens</InputLabel>
                    <Select
                        labelId="page-size-label"
                        value={pageSize}
                        label="Itens"
                        onChange={(e) => onPageSizeChange(Number(e.target.value))}
                    >{pageSizeOptions.map((option) => (
                        <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                    </Select>
                </FormControl>
            </Box>

            <Box className="admin-pagination-right">
                <Typography
                    variant="body2"
                    sx={{
                        color: '#666',
                        mr: 1,
                        fontSize: isSmallScreen ? '0.75rem' : '0.875rem',
                    }}
                >
                    {total === 0 ? '0 itens' : `${rangeStart}–${rangeEnd} de ${total}`}
                </Typography>
                <Pagination
                    count={totalPages}
                    page={page + 1}
                    onChange={(_, newPage) => onPageChange(newPage - 1)}
                    size={isSmallScreen ? 'small' : 'medium'}
                    siblingCount={isSmallScreen ? 0 : 1}
                    boundaryCount={isSmallScreen ? 1 : 2}
                    sx={{
                        '& .MuiPaginationItem-root.Mui-selected': {
                            backgroundColor: '#f25d27',
                            color: '#fff',
                            '&:hover': { backgroundColor: '#d94e1f' },
                        },
                    }}
                />
            </Box>
        </Box>
    );
}
